import { s as stormLightTheme } from '../LocalModules/storm-ui-tokens/dist/esm/index-byfklTA-.js';

const defaultTheme = stormLightTheme;

export { defaultTheme as d };
//# sourceMappingURL=index-ClP9Eqnk.js.map
